import { useState } from 'react'
import './ImageViewer.scss'
import ImageZoomViewer from '../ImageZoomViewer/ImageZoomViewer.component'
import AssistanceImage from './../../../utils/resources/ModuleIcons/AsistanceTest.jpg'

const ImageViewer = (props: { onDeleteImage: () => void, formLock: boolean, imageFolder: string }) => {

    const [imageZoom, setImageZoom] = useState(false)


    const [signedURL] = useState()
    return (
        <>
            <ImageZoomViewer image={AssistanceImage} onHide={() => setImageZoom(false)} showModal={imageZoom} />
            <div className='ImageSmallContainer me-2 mt-2' >
                <button disabled={props.formLock} type='button' className="btn btn-danger delImgButton" onClick={() => props.onDeleteImage()}><i className="bi bi-x-circle"></i></button>
                <img className='imageSmall' src={AssistanceImage} onClick={() => setImageZoom(true)}></img>
            </div>
        </>
    )
}

export default ImageViewer